import React from 'react';
import { Stack, Grid, InputAdornment, IconButton, Box, MenuItem, FormControl } from '@mui/material';
import { StyledCard, StyledCardTitle, CustomInputLabel, CustomDatePicker, CustomSearch, InputProps, SelectInputProps, CustomSelect, FlexDiv } from '../../../../../custom/components';
import styles from '../../../../../custom/style.module.css';
import awbStyles from './airwaybill.module.css';
import { AttachFile as AttachFileIcon, Search } from '@mui/icons-material';
import dayjs from 'dayjs';
import { getAwbDetails } from 'utils/import';
import TableWrapper from 'components/pages/common/TanStackTableWrapper';

const Airwaybill = (props) => {
  const columns = [
    {
      accessorKey: 'awb',
      header: 'Airwaybill',
      size: 100,
      cell: info => {
        const row = info.row.original;
        if (row.flight_awbs?.length > 0) {
          const awbData = getAwbDetails(row);
          return awbData.awb_no;
        }
        return row?.code + '-' + row?.number;
      },
    },
    {
      accessorKey: 'pcs',
      header: 'Pcs',
      size: 80,
      cell: info => {
        const row = info.row.original;
        if (row.flight_awbs?.length > 0) {
          const awbData = getAwbDetails(row);
          return awbData.pcs;
        }
        return row?.pcs;
      },
    },
    {
      accessorKey: 'wgt',
      header: 'Wgt',
      size: 100,
      cell: info => {
        const row = info.row.original;
        if (row.flight_awbs?.length > 0) {
          const awbData = getAwbDetails(row);
          return awbData.wgt;
        }
        return row?.wgt;
      },
    },
    {
      accessorKey: 'org',
      header: 'Org',
      size: 60,
      cell: info => {
        const row = info.row.original;
        if (row.flight_awbs?.length > 0) {
          const awbData = getAwbDetails(row);
          return awbData.org;
        }
        return row?.org;
      },
    },
    {
      accessorKey: 'dest',
      header: 'Dest',
      size: 60,
      cell: info => {
        const row = info.row.original;
        if (row.flight_awbs?.length > 0) {
          const awbData = getAwbDetails(row);
          return awbData.dest;
        }
        return row?.dest;
      },
    },
    {
      accessorKey: 'forwarder',
      header: 'Forwarder',
      size: 200,
      cell: info => info.getValue(),
    },
    {
      id: 'action',
      header: <div className={`${styles.textCenter}`}>Action</div>,
      size: 100,
      enableSorting: false,
      enableColumnFilter: false,
      cell: info => {
        const row = info.row.original;
        return (
          <Stack
            direction='row'
            spacing={2}
            justifyContent='center'
            className={styles.actionIcons}
          >
            <div onClick={() => props.handlePopover('attached_docs', true, row.docs || row.notifications)}>
              <AttachFileIcon
                fontSize='small'
                className={`${styles.pointer}`}
              />
            </div>
          </Stack>
        );
      },
    },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <StyledCard>
          <FlexDiv><StyledCardTitle>Filter Airwaybill List</StyledCardTitle></FlexDiv>
          <Stack direction='row' alignItems={'center'} justifyContent='flex-end' mt={'-16px'}>
            <CustomSearch
              id='search'
              variant='outlined'
              size='small'
              type='search'
              placeholder='Enter AWB Number'
              name='awb'
              className={`${styles.brInput} ${styles.width245}`}
              value={props.searchOptions.search}
              onChange={(e) => props.handleChange(e, 'search')}
              InputProps={{
                endAdornment: <InputAdornment position='end'>
                  <IconButton
                    size='small'
                    aria-label='search'
                    edge='end'
                    onClick={() => props.search(true)}
                  >
                    <Search fontSize='inherit' />
                  </IconButton>
                </InputAdornment>,
              }}
              onKeyDown={
                (e) => {
                  if (e.key === 'Enter') {
                    props.search(true);
                  }
                }
              }
            />
          </Stack>
          <Grid container spacing={2} columnSpacing={4}>
            <Grid item xs={12} sm={6} md>
              <CustomInputLabel htmlFor='' aria-label='Enter From Date'>From</CustomInputLabel>
              <CustomDatePicker
                slotProps={{
                  textField: {
                    ...InputProps,
                    placeholder: 'From Date',
                    fullWidth: true
                  },
                }}
                className={styles.w100}
                format='DD MMM YYYY'
                name='from'
                value={dayjs(props.searchOptions.from)}
                // helperText={}
                onChange={(e) => props.handleChange(e, 'from')}
              />
            </Grid>
            <Grid item xs={12} sm={6} md>
              <CustomInputLabel htmlFor='' aria-label='Enter To Date'>To</CustomInputLabel>
              <CustomDatePicker
                slotProps={{
                  textField: {
                    ...InputProps,
                    placeholder: 'To Date',
                    fullWidth: true
                  },
                }}
                className={styles.w100}
                format='DD MMM YYYY'
                name='to'
                value={dayjs(props.searchOptions.to)}
                // helperText={}
                onChange={(e) => props.handleChange(e, 'to')}
              />
            </Grid>
            <Grid item xs={12} sm={6} md>
              <CustomInputLabel aria-label='Enter Org' id='org-label'>Org</CustomInputLabel>
              <FormControl fullWidth>
                <CustomSelect
                  {...SelectInputProps}
                  fullWidth
                  id='org'
                  labelId='org-label'
                  name='org'
                  value={props.filter.org}
                  onChange={props.onChangefilter}
                >
                  <MenuItem value=''>All</MenuItem>
                  {props.org && props.org.map(a => {
                    return (<MenuItem key={a} value={a} >{a}</MenuItem>);
                  })}
                </CustomSelect>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md>
              <CustomInputLabel aria-label='Enter Dest' id='dest-label'>Dest</CustomInputLabel>
              <FormControl fullWidth>
                <CustomSelect
                  {...SelectInputProps}
                  fullWidth
                  id='dest'
                  labelId='dest-label'
                  name='dest'
                  value={props.filter.dest}
                  onChange={props.onChangefilter}
                >
                  <MenuItem value=''>All</MenuItem>
                  {props.dest && props.dest.map(f => {
                    return (<MenuItem key={f} value={f}>{f}</MenuItem>);
                  })}
                </CustomSelect>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={1} lg={4} className={styles.sqIconsContainer}>
              <CustomInputLabel className={styles.colorTransparent}>-</CustomInputLabel>
              <IconButton disableRipple onClick={() => props.search(false)} className={styles.p0}>
                <Search fontSize='inherit' classes={{ root: `${styles.sqIcons} ${styles.mb0}` }} />
              </IconButton>
            </Grid>
          </Grid>
        </StyledCard>
      </Grid>

      <Grid item xs={12}>
        <StyledCard className={styles.positionRelative}>
          <FlexDiv className={styles.mb4}><StyledCardTitle>Airwaybills</StyledCardTitle></FlexDiv>
          {/* <CustomSearch
              id='search'
              name='awb'
              value={props.filter.awb}
              variant='outlined'
              size='small'
              placeholder='Enter Awb Number'
              onChange={props.onChangefilter}
              type='search'
              className={styles.brInput}
              InputProps={{
                endAdornment: <InputAdornment position='end'>
                  <IconButton
                    size='small'
                    aria-label='search'
                    edge='end'
                    onClick={() => props.onChangefilter({
                      target: {
                        name: 'awb_search',
                        value: ''
                      }
                    })}
                  >
                    <Search fontSize='inherit' />
                  </IconButton>
                </InputAdornment>,
              }}
              InputLabelProps={{ shrink: false }}
            /> */}
          <div className={styles.tableWrapper}>
            <Box className={`${styles.tableOuter} ${awbStyles.awbTableOuter}`}>
              <TableWrapper columns={columns} data={props.awbs} />
            </Box>
          </div>
        </StyledCard>
      </Grid>

    </Grid>
  );
};

export default Airwaybill;
